package org.gymly.ui.admin

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import org.gymly.theme.AdminColors

/**
 * Popup al solicitante cuando una acción quedó en cola de aprobación.
 */
@Composable
fun PendingApprovalNeededDialog(
    message: String,
    onDismiss: () -> Unit,
    onViewMyRequests: (() -> Unit)? = null,
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Text(
                "Necesitas aprobación",
                fontWeight = FontWeight.Bold,
                fontSize = 18.sp,
            )
        },
        text = {
            Text(
                message.ifBlank {
                    "Tu acción quedó pendiente. Se avisó a quienes tienen permiso para aprobarla."
                },
                color = AdminColors.Text,
                fontSize = 14.sp,
            )
        },
        confirmButton = {
            TextButton(onClick = onDismiss) {
                Text("Entendido", color = AdminColors.Primary, fontWeight = FontWeight.SemiBold)
            }
        },
        dismissButton = onViewMyRequests?.let { go ->
            {
                TextButton(
                    onClick = {
                        onDismiss()
                        go()
                    },
                ) {
                    Text("Ver mis solicitudes", color = AdminColors.TextMuted)
                }
            }
        },
    )
}
